/*
 *
 * IntermediateShelfPanel constants
 *
 */

enum ActionTypes {
  DISPLAY_INTERMEDIATE_SHELF_PANEL = 'app/IntermediateShelfPanel/DISPLAY_INTERMEDIATE_SHELF_PANEL',
  SELECTION_INTERMEDIATE_SHELVES = 'app/IntermediateShelfPanel/SELECTION_INTERMEDIATE_SHELVES',

  ADD_INTERMEDIATE_SHELVES_ON_SELECTION = 'app/IntermediateShelfPanel/ADD_INTERMEDIATE_SHELVES_ON_SELECTION',
  ADD_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE = 'app/IntermediateShelfPanel/ADD_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE',

  REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION = 'app/IntermediateShelfPanel/REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION',
  REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE = 'app/IntermediateShelfPanel/REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE',

  UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION = 'app/IntermediateShelfPanel/UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION',
  UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE = 'app/IntermediateShelfPanel/UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE',

  UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION = 'app/IntermediateShelfPanel/UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION',
  UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE = 'app/IntermediateShelfPanel/UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE',

  UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION = 'app/IntermediateShelfPanel/UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION',
  UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE = 'app/IntermediateShelfPanel/UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE',
}

export const marksISHeight = [
  {
    value: 125,
  },
  {
    value: 175,
  },
  {
    value: 225,
  },
];

export const marksISDepth = [
  {
    value: 250,
  },
  {
    value: 320,
  },
  {
    value: 420,
  },
  {
    value: 520,
  },
  {
    value: 620,
  },
];

export const ISDEPTH = [250, 320, 420, 520, 620];

export default ActionTypes;

export const MINIMAL_HEIGHT_FOR_ADDING_IS_SUGGESTION = 125;
